import { lazy, Suspense } from "react";
import { Navigate, Route, Routes as ReactRoutes } from "react-router-dom";

import SiteLayout from "../layouts/SiteLayout";
import PrivacyLayout from "../layouts/PrivacyLayout";
import ShopListPrivacyPolicy from "../components/policy/ShopListPolicy";
import StackClaskPrivacyPolicy from "../components/policy/StackClashPolicy";

const Home = lazy(() => import("../pages/Home"));
const Apps = lazy(() => import("../pages/Apps"));
const ShopListPage = lazy(() => import("../pages/ShopListPage"));
const StackClashPage = lazy(() => import("../pages/StackClashPage"));

const Routes = () => {
  return (
    <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
      <ReactRoutes>
        {/* Public portfolio pages */}
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/apps/shoplist" element={<ShopListPage />} />
          <Route path="/apps/stack-clash" element={<StackClashPage />} />
        </Route>

        {/* Store-linked privacy pages — URLs and content must not change */}
        <Route
          path="/privacy"
          element={
            <PrivacyLayout app="shoplist">
              <ShopListPrivacyPolicy />
            </PrivacyLayout>
          }
        />
        <Route
          path="/stackClash/privacy"
          element={
            <PrivacyLayout app="stackclash">
              <StackClaskPrivacyPolicy />
            </PrivacyLayout>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </ReactRoutes>
    </Suspense>
  );
};

export default Routes;
